<template>
    <div class="modal fade modal-upload" id="resetPassUser" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <div class="center-modal ex-input-center">

                        <div class="center-ttl font300 d-flex justify-content-center">
                            <i class="icon-lock-g mr-2 mt-1"></i>
                            <span class="font500 text-pink">
                                {{ $t('user.reset_pass.title') }}
                            </span>
                        </div>

                        <div class="error-message" v-if="alert_error" data-vv-scope='s1'>
                            <div class="d-flex">
                                <i class="icon-warning mr-2"></i>
                                <div class="errror-txt">
                                    <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                    <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                </div>
                            </div>
                        </div>

                        <div v-if="this.resetPassObj.ids.length > 0" data-vv-scope='s2'>
                            <div v-if="(listReset == null) && (init == true)" data-vv-scope='s3'>

                                <div class="d-flex justify-content-center">
                                    <div class="pr-2 w-165">
                                        <button class="btn btn-pink-53 w-100" :disabled="disabled" @click="resetPassUsers" ref="buttonResetPassUsers" type="button">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>

                                    <div class="pl-2 w-165">
                                        <button class="btn btn-gray-53 w-100" :disabled="disabled" data-dismiss="modal" type="button">
                                            {{ $t('button.cancel') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="(listReset != null) && (init == false)" data-vv-scope='s4'>

                                <p class="txc" v-for="item in listReset" :key="item.id">
                                    <span>{{ item.username }}</span> :
                                    <span>{{ item.password }}</span>
                                    <button class="btn btn-clipboard-cir" type="button" style="display:inline-flex;color:white" @click="copyPasswordToClipboard(item.password)">
                                       <div style="display: contents;">
                                            <i class="icon-copy-password"></i>
                                        </div>
                                    </button>
                                </p>

                                <div class="d-flex justify-content-center">
                                    <div class="pl-2 w-165">
                                        <button class="btn btn-pink-53 w-100" data-dismiss="modal" type="button" @click="closeModal">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>
                                    <div class="pl-2 w-165" v-show="listReset.length > 1">
                                        <button class="btn btn-deep-blue-53 w-100" type="button" style="display:inline-flex;color:white" @click="copysPasswordAndUserName(listReset)">
                                            {{ $t('button.pwCopy') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div class="txc">
                                {{ $t('user.general.no_select') }}
                            </div>
                            <div class="d-flex justify-content-center mt-4 pt-4">
                                <div class="pl-2 w-165">
                                    <button class="btn btn-pink-53 w-100" data-dismiss="modal">
                                        {{ $t('button.ok') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import UserManagementService from '@/services/admin/user.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';
import Utils from '@/helpers/utils';
import store from '@/store/index';

export default {
    name: 'DeleteUserManagement',
    props: {
        resetPassObj: [Object],
    },
    data () {
        return {
            alert_success: "",
            alert_error: "",

            loading: false,
            disabled: false,

            init: true,
            lists: null,
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
    },
    beforeMount () {
    },
    mounted () {
        let _this = this;
        $("#resetPassUser").on('show.bs.modal', function () {
            store.commit('loading', false);
        });
        $("#resetPassUser").on('hide.bs.modal', function () {
            _this.resetModal();
            // _this.$emit('unSlectAllUser');
            store.commit('loading', false);
        });
    },
    computed: {
        listReset: function () {
            this.$forceUpdate();
            if (this.lists && this.lists.length > 0) {
                let _list = [];
                $.each(this.lists, function (key, value) {
                    let item = {
                        id: value.id,
                        full_name: value.full_name,
                        password: value.password,
                        group_name: value.group_name,
                        username: value.username,
                        role_name: value.role_name,
                        valid_period_from: value.valid_period_from,
                        valid_period_to: value.valid_period_to,
                        mfa_registered: value.mfa_registered,
                    };
                    _list.push(item);
                });
                return _list;
            } else {
                return null;
            }
        },
    },
    watch: {
    },
    methods: {
        resetPassUsers: function resetPassUsers (event) {
            if (this.resetPassObj.ids.length < 0) {
                return false;
            }

            this.loading = true;
            this.disabled = true;

            UserManagementService.resetPassUser(this.resetPassObj.ids)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200) {
                        if (response.data) {
                            this.lists = response.data;
                            this.init = false;
                        } else {
                            $('#resetPassUser').modal('hide');
                            $('.modal-backdrop').remove();
                            this.$emit('unSlectAllUser');
                        }

                        this.alert_success = this.$t('success.reset_pass_success');
                        this.alert_error = "";

                        this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                    } else {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.reset_pass_fail');

                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.alert_error = this.$t('error.error_code_' + errorCode);
                        }

                        // this.$toasted.error(alert_error, {icon: 'fa-exclamation-triangle'});
                    }

                    if (response.status == 403) {
                        this.alert_success = "";
                        this.alert_error = this.$t('error.error_' + response.status);
                    }

                    this.loading = false;
                    this.disabled = false;

                    // this.$router.replace({path: '/admin/users', params: {alert_success: alert_success, alert_error: alert_error, force: true }});
                }).catch(error => {
                    this.alert_success = "";
                    this.alert_error = this.$t('fail.reset_pass_fail');

                    // $('#resetPassUser').modal('hide');
                    // $('.modal-backdrop').remove();
                    // this.$toasted.error(alert_error, {Icon: 'fa-exclamation-triangle'});

                    // this.$router.replace({path: '/admin/users', params: {alert_success: alert_success, alert_error: alert_error, force: true}});

                    this.loading = false;
                    this.disabled = false;
                });

            return false;
        },

        resetModal: function resetModal () {
            this.loading = false;
            this.disabled = false;
            this.init = true;
            this.lists = null;

            this.alert_success = "";
            this.alert_error = "";
        },

        closeModal: function resetModal () {
            this.$emit('unSlectAllUser');
            $("#resetPassUser").modal('hide');
        },

        copyPasswordToClipboard(password){
            //クリップボードへのコピーをするための一時的なDOM制御
            const copyFrom = document.createElement("textarea");
            copyFrom.textContent = password;
            const bodyElm = document.getElementsByTagName("body")[0];
            bodyElm.appendChild(copyFrom);
            copyFrom.select();
            const retVal = document.execCommand('copy');
            bodyElm.removeChild(copyFrom);
            this.alert_success = this.$t('user.copy_pass.title')
            this.$toasted.success(this.alert_success, {icon: 'fa-check'});
            return retVal;
        },
        copysPasswordAndUserName(arry){
            let copyText = '';
            for (const item of arry) {
                copyText += 'ID:' + item.username +'\tPW:' + item.password + '\n';
            }
            //クリップボードへのコピーをするための一時的なDOM制御
            const copyFrom = document.createElement("textarea");
            copyFrom.textContent = copyText;
            const bodyElm = document.getElementsByTagName("body")[0];
            bodyElm.appendChild(copyFrom);
            copyFrom.select();
            const retVal = document.execCommand('copy');
            bodyElm.removeChild(copyFrom);
            this.alert_success = this.$t('user.copy_pass.title')
            this.$toasted.success(this.alert_success, {icon: 'fa-check'});
            return retVal;
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/UserManagement/ResetPass.vue